import styled from 'styled-components';
import formControlMixin from './formControlMixin';

const Input = styled.input<{ hasError?: boolean }>`
  ${formControlMixin}
`;

export default Input;
